<template>
  <figure class="highcharts-figure">
    <highcharts ref="chart" :options="options" />
    <p class="highcharts-description highcharts-linked-description">
      <strong>Figure : </strong>
      <span v-html="$t('compGraphicsFoodsEmissionFactors.help')" />
    </p>
  </figure>
</template>

<script>
import '@/plugins/highcharts.js'

export default {
  name: 'FoodsEmissionFactors',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  computed: {
    series: function () {
      let series = [
        {
          name: this.$t('compGraphicsFoodsEmissionFactors.agriculture'),
          data: []
        },
        {
          name: this.$t('compGraphicsFoodsEmissionFactors.transformation'),
          data: []
        },
        {
          name: this.$t('compGraphicsFoodsEmissionFactors.packaging'),
          data: []
        },
        {
          name: this.$t('compGraphicsFoodsEmissionFactors.transport'),
          data: []
        },
        {
          name: this.$t('compGraphicsFoodsEmissionFactors.distribution'),
          data: []
        },
        {
          name: this.$t('compGraphicsFoodsEmissionFactors.consumption'),
          data: []
        }
      ]
      // add beef
      series[0].data.push(27.09 * 0.978)
      series[1].data.push(27.09 * 0.004)
      series[2].data.push(27.09 * 0.006)
      series[3].data.push(27.09 * 0.006)
      series[4].data.push(27.09 * 0.003)
      series[5].data.push(27.09 * 0)
      // add shrimp
      series[0].data.push(21.79 * 0.816)
      series[1].data.push(21.79 * 0)
      series[2].data.push(21.79 * 0.042)
      series[3].data.push(21.79 * 0.098)
      series[4].data.push(21.79 * 0.021)
      series[5].data.push(21.79 * 0.022)
      // add chocolate
      series[0].data.push(16.88 * 0.885)
      series[1].data.push(16.88 * 0.049)
      series[2].data.push(16.88 * 0.011)
      series[3].data.push(16.88 * 0.048)
      series[4].data.push(16.88 * 0.005)
      series[5].data.push(16.88 * 0)
      // add pork
      series[0].data.push(10.14 * 0.804)
      series[1].data.push(10.14 * 0.142)
      series[2].data.push(10.14 * 0.033)
      series[3].data.push(10.14 * 0.011)
      series[4].data.push(10.14 * 0.006)
      series[5].data.push(10.14 * 0.001)
      // add coffee
      series[0].data.push(9.99 * 0.939)
      series[1].data.push(9.99 * 0.036)
      series[2].data.push(9.99 * 0.005)
      series[3].data.push(9.99 * 0.016)
      series[4].data.push(9.99 * 0.002)
      series[5].data.push(9.99 * 0)
      // add checken
      series[0].data.push(6.97 * 0.823)
      series[1].data.push(6.97 * 0.104)
      series[2].data.push(6.97 * 0.025)
      series[3].data.push(6.97 * 0.025)
      series[4].data.push(6.97 * 0.012)
      series[5].data.push(6.97 * 0.007)
      // add cheese
      series[0].data.push(6.16 * 0.835)
      series[1].data.push(6.16 * 0.071)
      series[2].data.push(6.16 * 0.037)
      series[3].data.push(6.16 * 0.028)
      series[4].data.push(6.16 * 0.015)
      series[5].data.push(6.16 * 0.004)
      // add sardine
      series[0].data.push(6.05 * 0.534)
      series[1].data.push(6.05 * 0.06)
      series[2].data.push(6.05 * 0.371)
      series[3].data.push(6.05 * 0.023)
      series[4].data.push(6.05 * 0.007)
      series[5].data.push(6.05 * 0.002)
      // add palm oil
      series[0].data.push(6.04 * 0.691)
      series[1].data.push(6.04 * 0.087)
      series[2].data.push(6.04 * 0.083)
      series[3].data.push(6.04 * 0.126)
      series[4].data.push(6.04 * 0.001)
      series[5].data.push(6.04 * 0)
      // add egg
      series[0].data.push(3.17 * 0.941)
      series[1].data.push(3.17 * 0)
      series[2].data.push(3.17 * 0.023)
      series[3].data.push(3.17 * 0.025)
      series[4].data.push(3.17 * 0.004)
      series[5].data.push(3.17 * 0.005)
      // add rice
      series[0].data.push(2.75 * 0.936)
      series[1].data.push(2.75 * 0)
      series[2].data.push(2.75 * 0.022)
      series[3].data.push(2.75 * 0.035)
      series[4].data.push(2.75 * 0.005)
      series[5].data.push(2.75 * 0)
      // add olive.oil
      series[0].data.push(0.98 * 0.88)
      series[1].data.push(0.98 * 0.012)
      series[2].data.push(0.98 * 0.065)
      series[3].data.push(0.98 * 0.032)
      series[4].data.push(0.98 * 0.008)
      series[5].data.push(0.98 * 0)
      // add lettuce
      series[0].data.push(0.94 * 0.557)
      series[1].data.push(0.94 * 0)
      series[2].data.push(0.94 * 0)
      series[3].data.push(0.94 * 0.235)
      series[4].data.push(0.94 * 0.135)
      series[5].data.push(0.94 * 0.07)
      // add tomato
      series[0].data.push(0.58 * 0.582)
      series[1].data.push(0.58 * 0)
      series[2].data.push(0.58 * 0)
      series[3].data.push(0.58 * 0.317)
      series[4].data.push(0.58 * 0.052)
      series[5].data.push(0.58 * 0.047)
      // add apple
      series[0].data.push(0.4 * 0.642)
      series[1].data.push(0.4 * 0)
      series[2].data.push(0.4 * 0)
      series[3].data.push(0.4 * 0.29)
      series[4].data.push(0.4 * 0.047)
      series[5].data.push(0.4 * 0.019)
      // add lentils
      series[0].data.push(0.4 * 0.514)
      series[1].data.push(0.4 * 0)
      series[2].data.push(0.4 * 0.157)
      series[3].data.push(0.4 * 0.125)
      series[4].data.push(0.4 * 0.134)
      series[5].data.push(0.4 * 0.067)
      return series
    },
    categories: function () {
      return [
        this.$t('compGraphicsFoodsEmissionFactors.beef'),
        this.$t('compGraphicsFoodsEmissionFactors.shrimp'),
        this.$t('compGraphicsFoodsEmissionFactors.chocolate'),
        this.$t('compGraphicsFoodsEmissionFactors.pork'),
        this.$t('compGraphicsFoodsEmissionFactors.coffee'),
        this.$t('compGraphicsFoodsEmissionFactors.chicken'),
        this.$t('compGraphicsFoodsEmissionFactors.cheese'),
        this.$t('compGraphicsFoodsEmissionFactors.sardine'),
        this.$t('compGraphicsFoodsEmissionFactors.palm.oil'),
        this.$t('compGraphicsFoodsEmissionFactors.egg'),
        this.$t('compGraphicsFoodsEmissionFactors.rice'),
        this.$t('compGraphicsFoodsEmissionFactors.olive.oil'),
        this.$t('compGraphicsFoodsEmissionFactors.lettuce'),
        this.$t('compGraphicsFoodsEmissionFactors.tomato'),
        this.$t('compGraphicsFoodsEmissionFactors.apple'),
        this.$t('compGraphicsFoodsEmissionFactors.lentils')
      ]
    },
    options: function () {
      let self = this
      return {
        chart: {
          type: 'bar'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: this.categories
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('compGraphicsFoodsEmissionFactors.kg.co2e.kg')
          },
          stackLabels: {
            enabled: true,
            formatter () {
              return `${this.total.toFixed(2)}`
            }
          }
        },
        tooltip: {
          formatter: function () {
            let tooltip = this.points[0].x + ' <br />'
            for (let i in this.points) {
              tooltip +=
                '<span style="color:' +
                this.points[i].series.color +
                ';">\u25CF ' +
                '</span> '
              tooltip +=
                this.points[i].series.name +
                ': <b>' +
                Math.round(this.points[i].y * 100) / 100
              tooltip +=
                '</b> ' +
                self.$t('compGraphicsFoodsEmissionFactors.kg.co2e.kg') +
                ' <br />'
            }
            return tooltip
          },
          shared: true
        },
        plotOptions: {
          series: {
            stacking: 'normal',
            pointWidth: 15,
            dataLabels: {
              enabled: false
            }
          }
        },
        exporting: {
          enabled: false
        },
        series: this.series
      }
    }
  }
}
</script>

<style scoped>
.highcharts-figure {
  min-width: 320px;
  max-width: 700px;
  margin: 1em auto;
}
.highcharts-description {
  text-align: center;
  color: '#777777';
  font-style: italic;
}
</style>
